'use client';

import clsx from 'clsx';
import { DateTime } from 'luxon';
import { useGameRegistryData } from '~/components/layouts/GameDataProvider';
import type { IGame } from '~/types/api';
import { GAME_STATES, ISSUE_STATUSES } from '~/utils/gameState';

interface GameStatusProps {
  game: IGame;
  isVenue?: boolean;
}

export function GameStatus({ game, isVenue = false }: GameStatusProps) {
  // Access the game data through context
  const { data } = useGameRegistryData(game);

  // Use the game data hook to get live updates

  // Use either live data from context or fallback to prop
  const recordStatus = data?.recordStatus || game.recordStatus;
  const isMakeupGame =
    game?.cancelledGame !== null &&
    recordStatus !== GAME_STATES.POSTPONED &&
    recordStatus !== GAME_STATES.IN_PROGRESS;

  const gameDateTime = DateTime.fromISO(
    game?.cancelledGame?.gameDateIso ?? '',
  ).toLocal();
  const date = gameDateTime.isValid
    ? gameDateTime.toFormat('MMMM d, yyyy', { locale: 'en-US' })
    : '';
  const time = gameDateTime.isValid
    ? gameDateTime.toFormat('h:mm a ZZZZ', { locale: 'en-US' })
    : '';

  return (
    <>
      {isVenue ? (
        <div className="my-4 rounded-sm px-2 text-sm font-bold uppercase [&_span]:leading-[20px]"></div>
      ) : (
        <>
          <div
            className={clsx(
              'my-4 rounded-sm bg-[#DB1500] px-2 text-sm font-bold uppercase [&_span]:leading-[20px]',
              recordStatus === GAME_STATES.IN_PROGRESS &&
                '!bg-white !text-black',
              isMakeupGame && '!bg-[#FFF3B3] !text-black',
            )}
          >
            {recordStatus === GAME_STATES.IN_PROGRESS && (
              <div className="flex items-center gap-x-1">
                <span className="animate-live-pulse font-roboto text-[30px] text-[#DB1500]">
                  •
                </span>
                <span className="font-roboto text-[12px] font-medium">
                  LIVE
                </span>
              </div>
            )}
            {ISSUE_STATUSES.includes(recordStatus as any) && (
              <div className="flex items-center gap-x-1">
                <span>{recordStatus}</span>
              </div>
            )}
            {isMakeupGame && (
              <div className="flex items-center gap-x-1">
                <span>Makeup Game</span>
              </div>
            )}
          </div>
          {isMakeupGame && (
            <p className="text-3 text-center font-medium normal-case max-lg:mt-4 lg:px-4 lg:pb-4">
              Makeup of postponed game on {date || 'TBA'}
            </p>
          )}
        </>
      )}
    </>
  );
}
